import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/members/$memberId/"
)({
  component: MemberIndexRedirect,
})

function MemberIndexRedirect() {
  const { memberId } = Route.useParams()

  return (
    <Navigate
      to="/members/$memberId/$tabKey"
      params={{ memberId, tabKey: "details" }}
    />
  )
}
